module.exports = __webpack_public_path__ + "static/plans-img-3-7c49891a64ce3cf169df0221e951a8e3.png";